export default __webpack_public_path__ + "static/media/small-logo.39e675b5.svg";